<template>
  <RouterLink
    v-if="type === 'internal'"
    :to="path"
    :append="append"
    class="button text-base xl:text-lg btn-hover"
  >
    {{ cta }}
    <IconBase
      v-if="icon"
      :icon="icon"
      :size="size"
      class="ml-5"
    />
  </RouterLink>

  <a
    v-else
    :href="path"
    target="_blank"
    class="button text-base xl:text-lg btn-hover"
  >
    {{ cta }}
    <IconBase
      v-if="icon"
      :icon="icon"
      :size="size"
      class="ml-5"
    />
  </a>
</template>

<script>
import { mapState } from 'vuex'
import IconBase from '@/components/icons/IconBase.vue'

export default {
  name: 'ButtonMain',

  components: {
    IconBase
  },

  props: {
    cta: {
      type: String,
      default: 'Call to action'
    },
    icon: {
      type: [ String, Boolean ],
      default: false
    },
    type: {
      type: String,
      default: 'internal'
    },
    path: {
      type: String,
      default: ''
    },
    size: {
      type: String,
      default: '22px'
    },
    append: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    ...mapState([ 'touch '])
  }
}
</script>

<style scoped>
/* .button styles in index.css */
</style>
